
import Promise from "bluebird"
import {
  q_ajax_3,
  ERROR_HANDLER_ACTIONS as AJAX_ERROR_HANDLER_ACTIONS,
} from "app/utils/q_ajax/q_ajax_3"


import I18n from "plugins/i18n-js"

interface Input {
  user_authentication_handle: string,

  serviced_apartment_entry_id: string | number,
}

/* eslint-disable no-unused-vars */
enum ResultTypeEnums {
  SUCCESS = "SUCCESS",
  UNAUTHENTICATED = "UNAUTHENTICATED",
  INVALID = "INVALID",
  SERVER_ERROR = "SERVER_ERROR",
}
/* eslint-enable no-unused-vars */

interface PromiseResolvePayload {
  result_type: ResultTypeEnums,
  data?: {},
}

const destroy = ({user_authentication_handle, serviced_apartment_entry_id}: Input): Promise<any> => {
  return Promise.resolve(
    import(
      "plugins/js-routes"
    )
  )
  .then((Routes) => {
    return q_ajax_3(
      {
        url:      Routes.destroy_api_web_app_serviced_apartment_entry_user_shortlistings_path(),
        type:     "DELETE",

        // Expect JSON in response
        dataType: "JSON",

        // Sending JSON to server
        contentType:  "application/json; charset=utf-8",
        data:         JSON.stringify({
          user_authentication_handle:   user_authentication_handle,
          serviced_apartment_entry_id:  serviced_apartment_entry_id,

          locale: I18n.locale,
        }),
      },
      {
        custom_error_handler: ({http_status_code}) => {
          if (http_status_code === 401) {
            return AJAX_ERROR_HANDLER_ACTIONS.STOP_RETRY
          }
          if (http_status_code === 422) {
            return AJAX_ERROR_HANDLER_ACTIONS.STOP_RETRY
          }

          return AJAX_ERROR_HANDLER_ACTIONS.CONTINUE_RETRY
        },
      },
    )
  })
  .then(() => {
    return (
      {
        result_type: ResultTypeEnums.SUCCESS,
        data: {},
      }
    )
  })
  .catch((reason_or_error) => {
    if (reason_or_error instanceof Error) {
      throw reason_or_error
    }

    const { response } = reason_or_error
    switch (response.status) {
      case 500:
      case 502:
      case 503:
      case 504:
        return ({
          result_type: ResultTypeEnums.SERVER_ERROR,
        })
      case 401:
        return ({
          result_type: ResultTypeEnums.UNAUTHENTICATED,
        })
      case 422:
        return ({
          result_type: ResultTypeEnums.INVALID,
        })
      default:
        return ({
          result_type: ResultTypeEnums.INVALID,
        })
    }
  })
}

export {
  destroy,
  ResultTypeEnums,
}
